<form [formGroup]="addEditLibraryForm" autocomplete="off">
  <div class="form-controls-padding">
    <mat-form-field appearance="outline" hideRequiredMarker="true">
      <mat-label i18n="@@libraryNameLabel">Library name</mat-label>
      <input
        matInput
        type="text"
        placeholder="What are you working on?"
        i18n-placeholder="@@libraryNamePlaceholder"
        formControlName="libraryName"
        cdkFocusInitial
      />
      @if (emptyLibraryName()) {
        <mat-error i18n="@@emptyLibraryNameError">
          Please enter a library name
        </mat-error>
      }
      @if (!uniqueLibraryName()) {
        <mat-error i18n="@@uniqueLibraryNameError">
          Another library has this name, please choose another name
        </mat-error>
      }
    </mat-form-field>

    @if (enableProfilerLibrarySelection) {
      <mat-form-field appearance="outline" hideRequiredMarker="true">
        <mat-label i18n="@@attachedProfilerLabel">Attached profile</mat-label>
        <input
          matInput
          type="text"
          formControlName="profilerLibraryId"
          placeholder="Search profiles"
          i18n-placeholder="@@searchProfilesPlaceholder"
          (keyup)="onProfilerFilterChanged($event)"
          [matAutocomplete]="profilerAuto"
        />
        @if (addEditLibraryForm.controls.profilerLibraryId.value != null) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            aria-label="Clear attached profile"
            i18n-aria-label="@@clearAttachedProfilerLabel"
            (click)="clearProfilerLibrary($event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        }

        <mat-autocomplete
          #profilerAuto="matAutocomplete"
          [displayWith]="displayProfilerLibrary"
        >
          @for (
            profilerLibrary of filteredProfilerLibraries;
            track profilerLibrary.id
          ) {
            <mat-option [value]="profilerLibrary.id">
              {{ profilerLibrary.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
  </div>
</form>
